type Gender = 'masculino' | 'feminino' | 'neutro';

const genderMap: Record<string, Gender> = {
  'regulamento': 'masculino',
  'termo': 'masculino',
  'contrato': 'masculino',
  'manual': 'masculino',
  'aviso': 'masculino',
  'política': 'feminino',
  'declaração': 'feminino',
  'diretriz': 'feminino',
  'norma': 'feminino',
  'condição': 'feminino',
  'regulamentos': 'masculino',
  'termos': 'masculino',
  'contratos': 'masculino',
  'manuais': 'masculino',
  'avisos': 'masculino',
  'políticas': 'feminino',
  'declarações': 'feminino',
  'diretrizes': 'feminino',
  'normas': 'feminino',
  'condições': 'feminino',
};

/**
 * Verifica se o título está no plural
 * @param title - Título do termo
 * @returns true se estiver no plural, false caso contrário
 */
export function isPlural(title: string): boolean {
  const lower = title.toLowerCase();
  const words = lower.split(/\s+/).map(word => word.replace(/[.,!?;:()]/g, ''));
  
  const pluralKeywords = Object.keys(genderMap).filter(key =>
    key.endsWith('s') || key.endsWith('ões') || key.endsWith('ais') ||
    key.endsWith('eis') || key.endsWith('óis') || key.endsWith('ues') ||
    key.endsWith('ães')
  );
  
  for (const word of words) {
    if (pluralKeywords.some(pluralKey => word === pluralKey)) {
      return true;
    }
  }
  
  for (const word of words) {
    const exceptions = ['óculos', 'lápis', 'ônibus', 'programa', 'privacidade'];
    
    if (exceptions.some(exception => word === exception)) {
      continue;
    }
    
    const pluralEndings = ['ões', 'ais', 'eis', 'óis', 'ues', 'ães'];
    const hasPluralEnding = pluralEndings.some(ending => word.endsWith(ending));
    const endsWithS = word.endsWith('s') && word.length > 3;
    
    if (hasPluralEnding || endsWithS) {
      return true;
    }
  }
  
  return false;
}

/**
 * Retorna o artigo apropriado para o título do termo
 * @param title - Título do termo
 * @returns O artigo apropriado (o, a, os, as, o(a), os(as))
 */
export function getArticle(title: string): string {
  const lower = title.toLowerCase();
  const plural = isPlural(lower);
  
  const words = lower.split(/\s+/);
  let keyword: string | undefined;
  let gender: Gender = 'neutro';
  
  for (const word of words) {
    const cleanWord = word.replace(/[.,!?;:()]/g, '');
    
    if (genderMap[cleanWord]) {
      keyword = cleanWord;
      gender = genderMap[cleanWord];
      break;
    }
  }
  
  if (!keyword) {
    keyword = Object.keys(genderMap).find(word =>
      lower.includes(word) && word.length > 3
    );
    gender = keyword ? genderMap[keyword] : 'neutro';
  }
  
  if (plural) {
    switch (gender) {
      case 'masculino':
        return 'os';
      case 'feminino':
        return 'as';
      default:
        return 'os(as)';
    }
  } else {
    switch (gender) {
      case 'masculino':
        return 'o';
      case 'feminino':
        return 'a';
      default:
        return 'o(a)';
    }
  }
}

/**
 * Formata o texto de aceite do termo
 * @param title - Título do termo
 * @returns Texto formatado "Li e aceito [artigo] [título]"
 */
export function formatTermAcceptanceText(title: string): string {
  const article = getArticle(title.toLowerCase());
  return `Li e aceito ${article} ${title.toLowerCase()}`;
}
